export const errorMessage = {
    email: 'Email not valid.',
    INVALID_PHONE:"Phone Number contains invalid Characters. Enter a Valid Phone Number.",
    INVALID_DIGITS: "Mobile number Must Contain 10 Digits. Enter a valid Mobile number.",
    NAME_ERROR:"Full Name is required.",
    ALREADY_LINKED: "The entered mobile number is already linked with another Beneficiary."
};

export const successMessage = {
    sessionCreated: 'Session created successfully.'
};